import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AppConfig } from '../../core/services/app-config.service';

@Injectable({
  providedIn: 'root',
})
export class AccountConsentsGuard implements CanActivate {

  constructor(private appConfig: AppConfig, private router: Router) {
  }

  canActivate(): Promise<boolean> | boolean {
    return this.appConfig.config.migration.bannerEnabled ? true : this.router.navigate(['dashboard']);
  }

}
